import React from "react";
import { connect } from "react-redux";

import withStyles from "@material-ui/styles/withStyles";

import {
  Show,
  MultiCardShowLayout,
  ShowCard,
  PageFooter,
  EditButton,
  BackButton,
  SimpleShowLayout,
  TextField,
  FunctionField,
  RestMethods
} from "jazasoft";
import { Role } from "../../utils/types";

import { dataProvider } from "../../App";

const fieldOptions = {
  xs: 12,
  sm: 4
};

const Footer = ({ resource, i18nKey, basePath, record }) => (
  <PageFooter style={{ width: "100%" }}>
    <EditButton
      style={{ margin: "1em" }}
      resource={resource}
      i18nKey={i18nKey}
      basePath={basePath}
      record={record}
      color="primary"
      variant="contained"
    />
    <BackButton style={{ margin: "1em" }} variant="contained" />
  </PageFooter>
);

const viewStyle = theme => ({
  container: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between"
  },
  app: {
    width: "46%"
  },
  padding: {
    paddingTop: "1.5em"
  },
  fullWidth: {
    width: "100%"
  }
});

class UserView extends React.Component {
  state = {
    config: {}
  };

  componentDidMount() {
    this.fetchConfigAsync();
  }

  fetchConfigAsync = async () => {
    const options = {
      url: "permissions/configs",
      method: "get"
    };
    try {
      const response = await dataProvider(RestMethods.CUSTOM, null, options);
      this.setState({ config: response.data });
    } catch (e) {
      console.log(e);
    }
  };

  render() {
    const { classes, dispatch, ...props } = this.props;
    const record = props.record || {};
    const roleList = (record.roleList && record.roleList.map(r => r.role && r.role.roleId)) || [];
    const roles = props.roles || [];

    const config = this.state.config || {};

    return (
      <Show cardWrapper={false} {...props}>
        <MultiCardShowLayout className={classes.container} footer={<Footer />}>
          <ShowCard className={classes.fullWidth} title="User Info">
            <TextField label="Full Name" source="fullName" {...fieldOptions} />
            <TextField label="Username" source="username" {...fieldOptions} />
            <TextField label="Email" source="email" {...fieldOptions} />
            <TextField label="Mobile" source="mobile" {...fieldOptions} />
            {roles.includes(Role.MASTER) && !roleList.includes(Role.MASTER) && <TextField label="Tenant" source="tenant.name" {...fieldOptions} />}
            {(roleList.includes(Role.MASTER) || roleList.includes(Role.SUPER_USER)) && (
              <FunctionField label="Role" render={(record = {}) => record.roleList && record.roleList.map(r => r.role && r.role.name).join(", ")} />
            )}
            {roleList.includes(Role.SUPER_USER) && (
              <FunctionField label="Apps" render={(record = {}) => record.appList && record.appList.map(a => a.name).join(", ")} xs={12} fullWidth />
            )}
          </ShowCard>

          {roleList.length > 0 &&
            !(roleList.includes(Role.MASTER) || roleList.includes(Role.SUPER_USER)) &&
            record.appList &&
            record.appList.map((app, idx) => (
              <ShowCard
                className={classes.app}
                key={idx}
                title={app.name}
                content={() => {
                  const roles =
                    record.roleList &&
                    record.roleList
                      .filter(r => r.appId === app.id)
                      .map(r => r.role && r.role.name)
                      .join(", ");
                  const permissionKeys = config[app.appId] ? config[app.appId].filter(p => p && p.type === "PER_USER") : [];
                  const permissions = permissionKeys.reduce(
                    (acc, e) => ({
                      ...acc,
                      [e.key]:
                        record.permissionList &&
                        record.permissionList
                          .filter(p => p.app && p.app.id === app.id && p.key === e.key)
                          .map(p => p.name)
                          .join(", ")
                    }),
                    {}
                  );
                  return (
                    <SimpleShowLayout className={classes.padding} record={{ roles, ...permissions }} footer={false}>
                      <TextField source="roles" xs={12} fullWidth />
                      {permissionKeys
                        .sort((a, b) => a.serialNo - b.serialNo)
                        .map((p, idx) => {
                          return <TextField key={idx} source={p.key} xs={12} fullWidth />;
                        })}
                    </SimpleShowLayout>
                  );
                }}
              />
            ))}
        </MultiCardShowLayout>
      </Show>
    );
  }
}

const mapStateToProps = (state, props) => ({
  record:
    state.jazasoft.resources[props.resource] &&
    state.jazasoft.resources[props.resource].data &&
    state.jazasoft.resources[props.resource].data[props.id]
});

export default connect(mapStateToProps)(withStyles(viewStyle)(UserView));
